import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { Question } from './question';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { TestInterface, TestResultInterface } from '../../../core';

@JsonObject('Test')
export class Test implements TestInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('AdvisoryModelCode', StringAdapter, true)
    private _advisoryModel: string = undefined;

    @JsonProperty('Questions', [Question], true)
    private _questions: Question[] = undefined;

    get advisoryModel(): string {
        return this._advisoryModel;
    }

    set advisoryModel(newModel: string) {
        this._advisoryModel = newModel;
    }

    get id(): Id {
        return this._id;
    }

    get name(): string {
        return this._name;
    }

    get questions(): Question[] {
        if (!this._questions) {
            this._questions = [];
        }

        return this._questions.sort((a: Question, b: Question) => {
            if (a.order < b.order) {
                return -1;
            } else if (a.order > b.order) {
                return 1;
            }

            return 0;
        });
    }

    loadResults(result: TestResultInterface) {
        this.questions.map((question) => {
            result.questions.map((resultQuestion) => {
                const fillOptions = (options, resultOptions) => {
                    options.map((option) => {
                        resultOptions.map((resultOption) => {
                            if (String(option.id) === String(resultOption.id)) {
                                option.selected = true;
                            }
                        });
                    });
                };

                if (String(question.id) === String(resultQuestion.id)) {
                    fillOptions(question.options, resultQuestion.options);
                    fillOptions(question.groupsOptions, resultQuestion.groupsOptions);
                }
            });
        });
    }

    reset() {
        this.questions.map((question) => {
            question.options.map((option) => (option.selected = false));
            question.groupsOptions.map((option) => (option.selected = false));
        });
    }
}
